module.exports = __webpack_public_path__ + "img/king-of-pops-3.d4901ff6.png";